const region = process.env.REACT_APP_REGION;
//const userPoolId = process.env.REACT_APP_USER_POOL_ID;
//const clientId = process.env.REACT_APP_CLIENT_ID;
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;
const redirectURL = process.env.REACT_APP_REDIRECT_URL;
const apiStage = process.env.REACT_APP_API_STAGE;
const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
const identityProvider = process.env.REACT_APP_IDP;
const signInRedirect = `${redirectURL}/login`;
//const signOutRedirect = `${redirectURL}/`;
const signOutRedirect = 'https://auth.deltacollege.edu/idp/profile/Logout';

const oauth = {
  domain : authDomain,
  scope : ['email', 'profile', 'openid','aws.cognito.signin.user.admin'],
  redirectSignIn : signInRedirect,
  redirectSignOut : signOutRedirect,
  responseType: 'code',
  options: {
    AdvancedSecurityDataCollectionFlag: false,
    IdentityProvider: identityProvider
  }
};

const apiGateway = {
  studentService: {
    URL: `https://${process.env.REACT_APP_STUDENT_SERVICE_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
    REGION: region
  },
  eops: {
    URL: `https://${process.env.REACT_APP_EOPS_API}.execute-api.${region}.amazonaws.com/${apiStage}`,
    REGION: region
  }
};

const Amplify = {
  API: {
    endpoints: [
      {
        name: "studentService",
        endpoint: apiGateway.studentService.URL + '/',
        region: apiGateway.studentService.REGION
      },
      {
        name: "eops",
        endpoint: apiGateway.eops.URL + '/',
        region: apiGateway.eops.REGION
      }
    ]
  },
  Auth: {
    identityPoolId: identityPoolId,
    region: region,
    userPoolId: ''
  }
};

export default {
  apiGateway,
  Amplify
}
